import React from 'react'

export const Section = ({ children }) => {
    return (
        <div className='relative shadow-none rounded mt-1 p-2 sm:p-4'>
            {children}
        </div>
    )
}
